import r from"react";export default function(e){var t=r.useRef();return r.useEffect(function(){t.current=e},[e]),t.current}
